import React from 'react';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Button } from '../ui';

/**
 * OAuth provider buttons — full-width stacked (auth-page template style).
 */
export default function OAuthProviderGrid({ onGoogle, onFacebook, onLinkedIn }) {
  return (
    <>
      <Button type="button" size="lg" fullWidth onClick={onGoogle} startIcon={<GoogleIcon />}>
        Continue with Google
      </Button>
      <Button type="button" size="lg" variant="outline" fullWidth onClick={onFacebook} startIcon={<FacebookIcon />}>
        Continue with Facebook
      </Button>
      <Button type="button" size="lg" variant="outline" fullWidth onClick={onLinkedIn} startIcon={<LinkedInIcon />}>
        Continue with LinkedIn
      </Button>
    </>
  );
}
